import { Grid } from "@mui/material";
import React from "react";
import Notificacion from "../../common/notificacion";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CustomLabel from "../../common/customLabel";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import colors from "../../../../config/colors";

import {
  iconoAtajo,
  mensajeAtajo,
  containerAtajo,
} from "../../../global/styles";

const Atajos = () => {
  var navigate = useNavigate();
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);
  const isUltra = infoAfiliado.isUltra;
  const isDark = isUltra && infoAfiliado.ultraDarkMode;
  const isUltraLight = isUltra && !infoAfiliado.ultraDarkMode;

  return (
    <Grid id="container-atajos" container columnSpacing={8}>
      <Grid item xs={12} md={4}>
        <Notificacion
          id="atajo-1"
          IconLeft={
            <DoneAllIcon
              style={{
                ...iconoAtajo,
                marginLeft: 2,
                fontSize: 75,
                color: isDark ? colors.ultraAccentLight : isUltraLight ? colors.ulAccent : colors.primary,
              }}
            />
          }
          message={
            <CustomLabel style={{
              ...mensajeAtajo,
              color: isDark ? colors.ultraSilver : isUltraLight ? colors.ulText : undefined,
            }}>
              Visualizar <strong>mis</strong> <br />
              <strong>datos.</strong>
            </CustomLabel>
          }
          style={{
            ...containerAtajo,
            ...(isDark ? {
              background: `linear-gradient(135deg, ${colors.ultraMid}, ${colors.ultraSurface})`,
              border: `1px solid ${colors.ultraAccentBorder}`,
              boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
            } : isUltraLight ? {
              background: colors.ulCard,
              border: `1px solid ${colors.ulBorder}`,
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
              borderRadius: 16,
            } : {}),
          }}
          onPress={() => navigate("profile")}
        />
      </Grid>
    </Grid>
  );
};

export default Atajos;
